import { Form, FormInstance, Spin, Tabs } from "antd"
import type React from "react"
import { useEffect, useState } from "react"
import DF from "DisplayFramework"
import DemandSubTab from "./DemandSubTab"
import ContractSubTab from "./ContractSubTab"
import GetLabel from "DisplayFramework/components/GetLabel"
import ReservationAnomalyTab from "./ReservationAnomalyTab"
import ReservationSubTab from "./ReservationSubTab"
import BulkUploadTab from "./BulkUploadTab" // Import du nouveau composant
import { useForm } from "antd/lib/form/Form"
import ReservationAnomalyTab2 from "./IncidentpaymentTab"
import IncidentpaymentTab from "./IncidentpaymentTab"

export type ConActivityAnomalyTabProps = {
  form: FormInstance;
  color?: string;
  tpauthid: number;
  tpid?: number;
  itemsCompanyHierarchyTree: any[];
  isActive?: boolean; // New prop to track if tab is active
  onTabActivated?: () => void; // Callback when tab becomes active
};
const ConActivityAnomalyTab= (props: ConActivityAnomalyTabProps) => {
  const [form] = useForm()
  const tptype = "CONC"
  const [color, setColor] = useState<string>()
  const [activeTabKey, setActiveTabKey] = useState<string>("1") // Track active tab

  useEffect(() => {
    if (tptype === "CONC") {
      setColor("green")
    } else if (tptype === "PM") {
      setColor("duck-blue")
    } else if (tptype === "SPM") {
      setColor("blue")
    }
  }, [tptype])

  // Handle tab change
  const handleTabChange = (key: string) => {
    setActiveTabKey(key)
  }

  // Callback for when a tab is activated
  const handleTabActivated = (tabKey: string) => {
    console.log(`Tab ${tabKey} activated and data refreshed`)
  }

  return (
    <DF.Provider pagcode="contractactivity">
      <Spin spinning={false}>
        <Form layout="vertical" form={form}>
          <Tabs className="tabs-border-top" activeKey={activeTabKey} onChange={handleTabChange}>
            <Tabs.TabPane forceRender tab={<GetLabel label="Incidentsrefused" className="font-size-15" />} key="1">
             <ReservationAnomalyTab
                  form={form}
                  tpauthid={0}
                  itemsCompanyHierarchyTree={[]}
                  isActive={activeTabKey === "1"}
                  onTabActivated={() => handleTabActivated("1")}
                />
            </Tabs.TabPane>
             <Tabs.TabPane forceRender tab={<GetLabel label="Invoiceanomaly" className="font-size-15"/>} key="2">
             
            </Tabs.TabPane>
            
            <Tabs.TabPane forceRender tab={<GetLabel label="Incidentpayment" className="font-size-15"/>} key="3">
              <IncidentpaymentTab
                  form={form}
                  tpauthid={0}
                  itemsCompanyHierarchyTree={[]}
                  isActive={activeTabKey === "3"}
                  onTabActivated={() => handleTabActivated("3")}
                />
            </Tabs.TabPane>
            
           
            
          
          </Tabs>
        </Form>
      </Spin>
    </DF.Provider>
  )
}

export default ConActivityAnomalyTab